import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { tokens } from 'styling/tokens'
import { GLWidget } from './GLWidget'

const META = [
  { label: 'Optimal', color: tokens.status.success.fg, cond: (f: number) => f > 75 },
  { label: 'Medium', color: tokens.status.warning.fg, cond: (f: number) => f <= 75 && f >= 35 },
  { label: 'Low', color: tokens.accent.base, cond: (f: number) => f < 35 && f >= 6 },
  { label: 'Warning', color: tokens.status.danger.fg, cond: (f: number) => f <= 5 },
]

export const GLFuelWidget = () => {
  const { machines } = useSelector((state: RootState) => state.globalView)

  const count = (condition: (fuelPercent: number) => boolean): number =>
    machines?.filter((machine) => condition(machine?.vehicle?.fuelRemainingPercent))?.length || 0

  const total = machines?.length || 0
  const rows = META.map((m) => {
    const value = count(m.cond)
    return {
      key: m.label,
      label: m.label,
      value,
      pct: total ? Math.round((value / total) * 100) : 0,
      color: m.color,
    }
  })

  return <GLWidget title='Fuel' rows={rows} />
}
